import { DURATIONS, iOS_SPRINGS, MOTION_EASINGS } from '@/lib/animation-constants';

export const MOTION_EASING = MOTION_EASINGS;

export const MOTION_DURATION = {
  instant: DURATIONS.instant / 1000,
  fast: DURATIONS.fast / 1000,
  normal: DURATIONS.normal / 1000,
  slow: DURATIONS.slow / 1000,
  slower: DURATIONS.slower / 1000,
} as const;

export const MOTION_TRANSITIONS = {
  fade: { duration: MOTION_DURATION.fast, ease: MOTION_EASING.standard },
  enter: { duration: MOTION_DURATION.normal, ease: MOTION_EASING.decelerate },
  exit: { duration: MOTION_DURATION.fast, ease: MOTION_EASING.accelerate },
  page: { duration: MOTION_DURATION.normal, ease: MOTION_EASING.standard },
  press: { duration: 0.12, ease: MOTION_EASING.standard },
  indicator: iOS_SPRINGS.snappy,
  overlay: iOS_SPRINGS.overlay,
} as const;

export const MOTION_VARIANTS = {
  fade: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  },
  pop: {
    hidden: { opacity: 0, scale: 0.98 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.98 },
  },
  page: {
    enter: { opacity: 0, y: 10 },
    center: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -6 },
  },
} as const;

export function createMotionShift(distance: number = 10) {
  return {
    hidden: { opacity: 0, y: distance },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: Math.round(distance * 0.5) },
  } as const;
}
